<template>
    <div id="catalog" class="I-column-main_db" role="main">
      <h2 class="c-titl_top"><i class="icon-search"></i> 機種一覧から探す</h2>
      <div id="category_search" class="category-box">
        <ul class="list_category">
          <li>
            <router-link :to="{ name: 'speclist', params: { Spec: '掘削機'}}">
            <img src="/catalog/img/catalog/category01.jpg"><span>掘削機（バックホー・油圧ショベル）</span></router-link>
          </li>
          <li>
            <router-link :to="{ name: 'speclist', params: { Spec: '解体'}}">
            <img src="/catalog/img/catalog/category19.jpg"><span>解体・林業・アタッチメント</span></router-link>
          </li>
          <li>
            <router-link :to="{ name: 'speclist', params: { Spec: 'レンタカー'}}">
            <img src="/catalog/img/catalog/category02.jpg"><span>レンタカー</span></router-link>
          </li>
          <li>
            <router-link :to="{ name: 'speclist', params: { Spec: '高所'}}">
            <img src="/catalog/img/catalog/category04.jpg"><span>高所作業車</span></router-link>
          </li>
          <li>
            <router-link :to="{ name: 'speclist', params: { Spec: '道路機械'}}">
            <img src="/catalog/img/catalog/category03.jpg"><span>道路機械</span></router-link>
          </li>
          <li>
            <router-link :to="{ name: 'speclist', params: { Spec: '整地'}}">
            <img src="/catalog/img/catalog/category09.jpg"><span>整地・運搬機械</span></router-link>
          </li>
        </ul>
        <ul class="list_category2">
          <li><router-link :to="{ name: 'speclist', params: { Spec: '水中ポンプ'}}">
          <img src="/catalog/img/catalog/category10.jpg"><span>水中ポンプ・水処理機械</span></router-link></li>
          <li><router-link :to="{ name: 'speclist', params: { Spec: '発電'}}">
          <img src="/catalog/img/catalog/category05.jpg"><span>発電・溶接・照明機器</span></router-link></li>
          <li><router-link :to="{ name: 'speclist', params: { Spec: 'コンプレッサ'}}">
          <img src="/catalog/img/catalog/category06.jpg"><span>コンプレッサ・エア機械</span></router-link></li>
          <li><router-link :to="{ name: 'speclist', params: { Spec: 'ハウス'}}">
          <img src="/catalog/img/catalog/category07.jpg"><span>ハウス・備品</span></router-link></li>
          <li><router-link :to="{ name: 'speclist', params: { Spec: '通信'}}">
          <img src="/catalog/img/catalog/category08.jpg"><span>通信計測機器</span></router-link></li>
          <li><router-link :to="{ name: 'speclist', params: { Spec: '保安'}}">
          <img src="/catalog/img/catalog/category20.jpg"><span>保安用品</span></router-link></li>
          <li><router-link :to="{ name: 'speclist', params: { Spec: 'コンクリート機器'}}">
          <img src="/catalog/img/catalog/category11.jpg"><span>コンクリート機器</span></router-link></li>
          <li><router-link :to="{ name: 'speclist', params: { Spec: '汎用'}}">
          <img src="/catalog/img/catalog/category12.jpg"><span>汎用機器</span></router-link></li>
        </ul>
        <h2 class="c-titl_top"><i class="icon-books"></i> 参考資料</h2>
        <ul class="list_document">
          <li><a href="/business/general-conditions/"><img src="/catalog/img/catalog/rental.jpg"><span>レンタル約款</span></a></li>
          <li><a href="/business/rental_support/"><img src="/catalog/img/catalog/support.jpg"><span>レンタル物件サポート特約制度</span></a></li>
          <li><a href="/business/insurance/"><img src="/catalog/img/catalog/guarantee.jpg"><span>レンタル保障制度</span></a></li>
          <li><a href="/useful/law/"><img src="/catalog/img/catalog/law.jpg"><span>法規</span></a></li>
          <li><a href="/useful/qualification/"><img src="/catalog/img/catalog/certificate.jpg"><span>資格</span></a></li>
          <li><a href="/useful/unit/"><img src="/catalog/img/catalog/unit.jpg"><span>単位</span></a></li>
          <li><a href="/product/guide/"><img src="/catalog/img/catalog/guide.jpg"><span>ご利用ガイド</span></a></li>
        </ul>
      </div>
    </div>
</template>

<script>
  export default {
    inject: ['setBreadcrumbContext'],
    data: function () {
      return {
      }
    },
    mounted: function (){
      this.setBreadcrumbContext(null, '')
    },
    methods: {
    },
    watch: {
    }
  }
</script>
